webpackJsonp([15400075347947],{

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _components = __webpack_require__(8);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PrivacyPolicyPage = function PrivacyPolicyPage(_ref) {
	    var data = _ref.data;
	    return _react2.default.createElement(
	        _components.PageWrapper,
	        { title: 'Privacy Policy' },
	        _react2.default.createElement(
	            'div',
	            { className: 'contentPage' },
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        { className: 'text-center' },
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            data.site.siteMetadata.title,
	                            ' , TERMS OF USE'
	                        ),
	                        _react2.default.createElement('br', null),
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'EFFECTIVE July 1, 2018'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            data.site.siteMetadata.title,
	                            ' '
	                        ),
	                        '(\u201Cus\u201D, \u201Cwe\u201D, \u201Cour\u201D) operates ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/' },
	                            data.site.siteMetadata.domain,
	                            ' '
	                        ),
	                        ', including any and all associated domains (\u201CWebsite\u201D). This Privacy Policy (\u201CPolicy\u201D) details what and how we collect, use, store, safeguard, and disclose the information from visitors, users, and clients (collectively \u201Cyou\u201D or \u201Cyour\u201D) who use Website and through the paid service we provide to obtain Federal Tax Identification Numbers from the Internal Revenue Service (\u201CIRS\u201D) (\u201CServices\u201D). We are committed to proactively managing and protecting your privacy and sensitive personal information.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'By accepting this Policy and Terms of Use (found',
	                        _react2.default.createElement(
	                            'a',
	                            { href: '/terms-of-services/' },
	                            'here'
	                        ),
	                        '), you consent to the collection, use, storage, protection, and disclosure of information as described herein and is a condition to your access, view, and usage of Website and Services.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'INFORMATION WE COLLECT'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Non-Personal Information'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Non-personal information is certain information that does not personally identify you that may be automatically collected when you access or use Website, including your computer or mobile device\u2019s internet protocol (IP) address, device and browser type, operating system, internet service provider, or mobile carrier. We may also collect information specific to your access and use of Website and Services including how you use, view, and interact with Website, the pages in the Website you visit, the content you search for, actions you take on Website, the date and time of access, referring and exit pages and URLs, number of clicks, and preferences generated based on data you submit.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Additionally, certain demographic data may be collected either through the access and use of Website or through Services including your age and gender.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Personal Information'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The Website does not automatically collect any personally identifiable information (\u201CPersonal Information\u201D) unless personally and voluntarily submitted by you. We request Personal Information when providing Services in order to properly identify, represent, and contact you. Such information includes your name, social security number, address, email address, telephone number, fax number, username, password, and credit card. By providing this information, you authorize us to collect, use, store, protect, and disclose the information in accordance with this Policy. While you are not required to provide Personal Information, refusal to do so may prevent you from accessing, or inhibit us from providing, Services.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may supplement Personal Information with additional information from public sources or third parties that may lawfully provide such information to us, such as consumer reporting agencies.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Correspondence'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We collect information and content provided through your communications and correspondence with us in connection with Website or Services either through customer service or other methods of inquiry. When doing so, you are contacting us and disclosing Personal Information at your own discretion and risk.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Business Information'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We collect information regarding your business when providing Services in order to properly represent you. This includes the entity name, description of your business, address, telephone number, fax number, organizational jurisdiction, name and address of the registered agent, name and address of directors, officers, managers, or members of your business, and status of your employees, if any. By providing this information, you authorize us to collect, use, store, protect, and disclose the information in accordance with this Policy.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Location Information'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'With your permission, we may collect physical location information provided through your device. This information is sufficiently precise in locating a specific person or device. You are asked when you initially access Website whether you would like to share your location. If you do not wish to share such information, you may decline to share your location and later opt out by changing your location services under your device settings. If you do not provide your location information, certain features on Website may be limited or won\u2019t function properly if at all.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'INFORMATION WE DO NOT COLLECT'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We do not intentionally solicit, collect, or disclose any information from children under 13 years of age. If we become aware that information was collected from any child under the age of 13, we will immediately and promptly delete such information and the child\u2019s account, if any.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Any parents or legal guardians of children under 13 who discovers that his or her child has provided us with Personal Information without proper consent must contact us via email at ',
	                        data.site.siteMetadata.supportEmail,
	                        '.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'HOW WE COLLECT INFORMATION'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'When you access and use Website and accept this Policy, you consent to the methods in which we collect information, some of which are described below:'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Cookies:'
	                            ),
	                            'Cookies are small data files with an anonymous unique identifier. The file is sent to your browser from a website that tracks, saves, and stores information about your interactions and usage of the website and is subsequently stored on your device\u2019s hard drive. We may collect and use both session cookies, which expire once the web browser is closed, and persistent cookies, which remain on the hard drive until deleted by you. This allows Website to provide you a personal, tailored, and interactive experience.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Local Storage:'
	                            ),
	                            'Local Storage is an industry-standard technology where a website or application can collect and store data kept on a person\u2019s device. We store your preferences through various forms of Local Storage including your device, browser web storage, HTML5 Local Storage, and caching. This provides information on how you interact with Website and display various content based on what you have viewed on other websites.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Pixel Tags:'
	                            ),
	                            'Pixel Tags, which also includes \u201Cclear GIFs\u201D or similar means, is most often a single pixel electronic image that is not ordinarily visible to you and associated with Cookies or Local Storage. Pixel Tags collect usage, geographical, and demographic data in connection with the use of Website and Services such as counting the number of users who visit certain pages on Website. This allows us to measure user responses, deliver branded and specialized services, and help determine the reach and effectiveness of promotional and marketing campaigns.'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            _react2.default.createElement(
	                                'strong',
	                                null,
	                                'Third-Party Tracking: '
	                            ),
	                            'We will sometimes work with third parties, including advertisers who use Cookies, Local Storage, and other technologies, to collect non-personal information and internet use and activity to analyze information over time and across various websites. This allows us to better understand the use and operation of Website and Services.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            ' '
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may perform these collection practices either directly or through a third-party vendor on our behalf.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'While most browsers accept Cookies and Local Storage by default, you may change and stop the use of Cookies or Local Storage through your browser settings. Removing or rejecting Cookies or Local Storage will affect your experience and how Website or Services may work for you. Additionally, some browsers feature a \u201CDo Not Track\u201D (\u201CDNT\u201D) option signaling to websites that you do not want to be tracked when activated. We do not currently respond to browser DNT signals because there is not yet an accepted standard of response.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'HOW WE USE INFORMATION WE COLLECT'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Use'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may use the information we collect from Website and Services for various reasons in accordance with applicable law, including:'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Provide and improve Services through technical and customer support, to solicit feedback, for research and development, and to inform you of new services and promotional offers;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'For standard business practices and purposes including establish and manage client accounts, merge your Personal Information with other available information to create a complete profile, contact clients regarding Services, and providing non-marketing correspondence such as statements, invoices, confirmations, notifications, technical updates, security alerts, and administrative messages;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Enable, administer, enhance, and personalize Website for users including tracking trends and analyzing use patters on Website and providing customized content specific to your interests, location, browsing and usage history, and responding to inquiries and complaints relating to the use of Website;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Send marketing communications relating to our business to the email address provided by you, with the option for you to opt-out of such communications;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Safeguard, deter, and investigate against illegal, fraudulent, or unauthorized access or activity on Website or through Services; and'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'Verify compliance with applicable legal requirements and our Terms of Use.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'You acknowledge and agree that my uploading, transmitting, or providing any information or data, other than Personal Information, on Website or through Services, you grant us, or anyone authorized by us, a non-exclusive, unrestricted, irrevocable, perpetual, royalty-free, and world-wide license to use, distribute, display, modify, reproduce, transmit, perform, and broadcast derivative works, in whole or in part, and in any manner or medium, at no cost whatsoever relating to your access and use of Website and Services.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Disclosure to Third Parties'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We do not sell, rent, or share any Personal Information to third parties for purposes of marketing or solicitation without your consent. However, we reserve the right to disclose certain Personal Information to third parties, at our sole discretion, in accordance with applicable law, including the following circumstances:'
	                    ),
	                    _react2.default.createElement(
	                        'ul',
	                        null,
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'When working with trusted third parties and affiliates, such as the IRS, who perform services for us as necessary to provide you Services or to fulfill your request, subject to this Policy;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'To safeguard, deter, and investigate against illegal, fraudulent, or unauthorized access or activity on Website or through Services;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'To protect and maintain the safety of you, us, and others and related property when neccessary;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'When there is a change of control or ownership of all or part of us including sale, transfer, acquisition, bankruptcy, or similar;'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'To establish and enforce our legal rights and rights under this Policy or our Terms of Use; and'
	                        ),
	                        _react2.default.createElement(
	                            'li',
	                            null,
	                            'As required by law or regulation or in connection with any ongoing or prospective legal proceedings.'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may disclose Non-Personal Information to our partners, advertisers, and other third parties for any reason at our discretion. Additionally, we may share information with social networking services if you use such services to access Website or Services in according with this Policy and to the extent permitted by the privacy agreement with the social networking service.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'SECURITY '
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We implement physical and technical security measures reasonably necessary to protect the information we collect from you from unauthorized access to, use, alteration, disclosure, or destruction of such information. However, we cannot guarantee these safeguards are absolutely secure and that Personal Information will remain free from unauthorized access resulting in misuse, alteration, disclosure, or destruction by third parties. Should we learn of a potential or actual security breach that puts your information at risk of unauthorized access, use, alteration, disclosure, or destruction, we may notify you so you can take appropriate next steps to protect and remedy the situation.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'As a preventative measure, we advise that you take precaution in handling sensitive or confidential information and do not provide such information through Website or insecure online methods of communication and contact us directly. If you have any questions or concerns regarding identity theft, refer to the Federal Trade Commission for more information at ',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.ftc.gov/bcp/menus/consumer/data.shtm' },
	                            'www.ftc.gov/bcp/menus/consumer/data.shtm'
	                        ),
	                        '.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'THIRD-PARTY WEBSITES'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This Policy only applies to Website. Website may contain links to other websites that are owned, operated, or controlled by unaffiliated third-parties that not required to comply with this Policy or adopt similar policy. Similarly, we may provide access to third-party applications and widgets, including social media, (\u201CThird-Party Applications\u201D) to allow interaction or content sharing. Such Third-Party Applications, including Facebook and Twitter, may collect information about you. We do not take responsibility for these websites and Third-Party Applications, their privacy practices, and do not make any warranties or representations regarding their content and services whatsoever. You utilize these websites and Third-Party Applications at your own risk. We recommend that you review the privacy policies for each website and Third-Party Application you access and use to understand how your personal information is collected, used, safeguarded, and disclosed.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'INTERNATIONAL DATA TRANSFER'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Website is maintained and hosted by a web server located in the United States. If you are located in, and accessing Website from, a non-U.S. jurisdiction and voluntarily provide Personal Information to us or we automatically collect certain information about you, such information will be transferred and processed in the U.S. By using Website and consenting to this Policy, you agree to such transfer and acknowledge that data protection may differ from your home country.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'USER RIGHTS'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'You have the right to access, change, and/or retract any voluntarily-submitted information by contacting us via email at ',
	                        data.site.siteMetadata.supportEmail,
	                        '. Upon notification, we will properly respond, update, and/or discard and destroy such information. Additionally, you have the right at any time to discontinue marketing or promotional communications from us by opting out. To do so, follow the unsubscribe instructions provided in each piece of communication or by contacting us via email at ',
	                        data.site.siteMetadata.supportEmail,
	                        '.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'California Privacy Rights'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Pursuant to California Civil Code Section 1798.83, California users may inquire as to whether a business has shared or disclosed Personal Information with affiliated or unaffiliated third parties for third-party direct marketing purposes. California users who wish to opt-out of, or have any questions or concerns regarding such disclosure, if any, may contact us via email at ',
	                        data.site.siteMetadata.supportEmail,
	                        '.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'CHANGES'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'This Policy is effective as of the date indicated herein. We may update or make changes to this Policy at any time, without notice to you, by publishing a new version on this page. Such changes will go into effect immediately upon posting. The current posted version of this Policy shall apply on the date you access or use Website or Services and shall only apply to information collected thereafter. As a result, you are encouraged to check this page each time you access Website and review for any updates or changes before using Website, Services, and/or submitting additional information to us. Your continued use of Website and Services after we post any updates or changes will constitute your acknowledgement of such modifications and consent to abide and be bound by the modified Policy.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            'CONTACT'
	                        )
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'If you have any questions regarding this Privacy Policy, or if you have concerns about a violation of your privacy and personal information, you may contact us via email at ',
	                        data.site.siteMetadata.supportEmail,
	                        '.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'INFORMATION WE COLLECT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Personal Information',
	                        _react2.default.createElement('br', null),
	                        'In order to provide certain of the Services to you, we collect certain information that personally identifies you (collectively, \u201CPersonal Information\u201D), including, without limitation, (1) names, addresses, email addresses, fax numbers, telephone numbers, usernames and passwords (collectively, \u201CContact Data\u201D), (2) name of your entity, name and address of your entity\u2019s registered agent, name and address of the directors, officers, members or managers of your entity, description of your business, geographical jurisdiction of formation of your entity, status of employees of your entity and your reason for applying for an employer identification number (collectively, \u201CBusiness Data\u201D), and (3) demographic data such as your gender and zip code (collectively, \u201CDemographic Data\u201D).In each case, you will be asked to provide Personal Information; the Website will not gather it surreptitiously. We may supplement your Personal Information that we gather or you provide with additional Personal Information from public sources or third parties (e.g., consumer reporting agencies) that may lawfully provide such Personal Information to us.We may share such Personal Information with the Internal Revenue Service and certain affiliates, business partners and third parties as detailed in this Privacy Policy and our Terms of Use. The Internal Revenue Service and such affiliates, business partners and third parties may contact you based on your Personal Information, even if you have opted into the National Do Not Call List administered by the Federal Trade Commission, any state\u2019s equivalent of the Do Not Call List or the Do Not Call List of an internal company. Once your Personal Information is obtained, the Internal Revenue Service and such affiliates, business partners and third parties may maintain your Personal Information whether or not you elect to continue to use the Services.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'You are under no obligation to provide us with your Personal Information, with the caveat that your refusal to do so may prevent you from using certain of the Services.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Automated Information'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'When you access or use the Website or the Services, we may automatically collect certain information about you and your computing device of the sort that browsers often automatically make available, including, without limitation, your computer\u2019s or mobile device\u2019s internet protocol address, browser type and operating system that you use, your internet service provider or mobile carrier and the type of handheld or mobile device that you use. We may also collect information about how you access or use the Website or the Services, including, without limitation, (i) the date and time that you access or use the Website or the Services, the webpage you were visiting before accessing the Website, pages that you visit on the Website (and, if you link to another website, the address of that website), the parts of the Website or the Services that you use, information for which you search, content that you view and actions that you take on or through the Website or the Services, and other statistics, (ii) emails you open and links you click within those emails, and (iii) how you view and interact with content or advertisements on or through the Website or the Services. The foregoing information is collectively referred to as \u201CAutomated Information.\u201D The Automated Information is anonymous information that does not personally identify you.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Communication Information'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'If you communicate with us through or in connection with the Services, you provide us the content of your communications, and if you contact us with a customer service or other inquiry, you provide us with the content of that communication (such information being collectively referred to as \u201CCommunication Information\u201D and, together with Personal Information, Automated Information, and any other information that we obtain from you through your access or use of the Website or the Services, \u201CInformation\u201D).'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'Children\u2019s Information'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'We do not solicit or knowingly collect any information from children under the age of 13. If a parent or legal guardian becomes aware that his or her child has provided us with any personally identifiable information without such parent\u2019s or legal guardian\u2019s consent, he or she should contact us at ',
	                        data.site.siteMetadata.supportEmail,
	                        ' . If we become aware that a child under 13 has provided us with any personally identifiable information, we will promptly delete such information and, if applicable, the child\u2019s account.Because we do not collect personally identifiable information from children under the age of 13, we have no such information to use or disclose to third parties.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'HOW WE USE INFORMATION WE COLLECT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may use any Information we collect in accordance with applicable law, including, without limitation, for the following purposes: (i) for everyday business purposes, such as establishing and managing your account, providing and improving the Services, providing customer support, developing new offerings and Services, and enhancing and personalizing your experience on or through the Website or the Services; (ii) to send you certain information, including confirmations, notifications, technical updates, security alerts and support and administrative messages, (iii) to link or combine your Information with other Information, (iv) to protect, investigate and deter against fraudulent, unauthorized or illegal activity on or through the Website or the Services; (v) to deliver content (including advertising content) tailored to your interests, location and browsing and usage history, both within the Website and on other third-party websites or applications; (vi) to comply with applicable legal requirements and our Terms of Use; (vii) to contact you (provided, however, that if required by applicable law, we will obtain your consent to contact you when and in the manner required by applicable law); and (viii) to send marketing emails to the email address you provide to us (provided, however, that any such marketing emails will tell you how to \u201Copt out\u201D of receiving further marketing emails).'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We expressly reserve the right to release any Information to third parties as we deem appropriate, so long as such disclosure is not in violation of applicable law, including, without limitation, under the following circumstances: (a) when required by applicable law or legal process, (b) to investigate or take action against illegal activity, suspected abuse or unauthorized access or use of the Website or the Services, (c) when we believe, in our sole and absolute discretion, that such disclosure is necessary to protect the property or safety of you, us or others, (d) to enforce our rights under our Terms of Use and (e) in connection with any sale, acquisition, sale of substantially all of our assets or other change of control transaction or transfer of ownership of all or a part of us (including in connection with bankruptcy or similar proceedings).'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Other than with respect to Personal Information, you acknowledge that by transmitting, posting or uploading any information, materials or data on or through the Website or in connection with the Services, you grant us, or anyone authorized by us, an unrestricted, non-exclusive, worldwide, royalty-free, perpetual, irrevocable license to use, modify, perform, display, broadcast, reproduce, create derivative works from, transmit or otherwise use or distribute, at no cost whatsoever, all such information, materials or data, in whole or in part, in any manner or medium (whether now known or hereafter developed), in connection with the Website, the Services or otherwise.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'HOW WE COLLECT INFORMATION'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may use certain data technologies to collect information, including, without limitation Cookies (as defined below), Local Storage (as defined below) and Pixel Tags (as defined below).'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u201CCookies\u201D'
	                        ),
	                        ' are small data files stored on your hard drive by a website. We may use both session Cookies (which expire once you close your web browser) and persistent Cookies (which stay on your computer until you delete them) to provide you with a more personal and interactive experience on the Website.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u201CLocal Storage\u201D'
	                        ),
	                        ' is an industry-standard technology that allows a website or app to store and retrieve data on a person\u2019s computer, mobile phone or other device. We may use device or HTML5 Local Storage, caching or other forms of Local Storage to store your preferences, help us remember certain information about how you interact with the Website or display content on the Website based upon what you have viewed on various other websites.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We may also use \u201Cpixel tags,\u201D \u201Cweb beacons,\u201D \u201Cclear GIFs\u201D or similar means (individually or collectively,',
	                        _react2.default.createElement(
	                            'strong',
	                            null,
	                            '\u201CPixel Tags\u201D'
	                        ),
	                        ') in connection with the Website or the Services to collect usage, demographic and geographical location data. A Pixel Tag is an electronic image, often a single pixel, that is ordinarily not visible to you and may be associated with Cookies on your hard drive or Local Storage. Pixel Tags allow us to count the number of users who have visited certain pages of the Website, to deliver branded services and to help determine the effectiveness of promotional or advertising campaigns.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'In addition, we may from time to time work with third-party companies, including advertisers, that use Cookies, Local Storage and other tracking technologies to collect non-identifying information about your activities on the Website or the Services in order to help us better understand the use and operation of the Website and the Services. These third parties may collect and analyze information about your online activities over time and across different websites when you access or use the Website or the Services. We do not exercise control over these third party websites or services. We encourage you to read the privacy policies or statements of the other websites and services you use.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'By accepting this Privacy Policy, and by accessing or using the Website or the Services, you are consenting to permit the use of Cookies, Local Storage and Pixel Tags by us and the third-party companies with which we work.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'Some browsers incorporate a \u201CDo Not Track\u201D (\u201CDNT\u201D) feature that, when activated, signals to websites that you do not want to be tracked. Because there is not yet an accepted standard for how to respond to browser DNT signals, we do not currently respond to them. You also can typically remove and reject Cookies or Local Storage from the Website with your browser settings. Many browsers are set to accept Cookies and Local Storage until you change your settings. If you remove or reject Cookies or Local Storage, it could affect how the Website works for you.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'In all circumstances, we may perform the foregoing information collection practices directly or use a third party vendor to perform these functions on our behalf. Also, if you access the Website or the Services from a social networking service, we may share information with such social networking service in accordance with this Privacy Policy and to the extent permitted by your agreement with such social networking service and its privacy settings.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'THIRD-PARTY WEBSITES'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'The Website may contain links to other websites not operated, owned or controlled by us, as well as third-party widgets and applications discussed above (collectively, \u201CThird-Party Websites\u201D). Third-Party Websites are under no obligation to comply with this Privacy Policy. Once you leave the Website, we suggest that you review the applicable privacy policy of the Third-Party Website and, if necessary, take any steps you deem reasonable or necessary to, in your discretion, protect your privacy. We are not responsible for the content or use of any Third-Party Websites or the privacy practices of such Third-Party Websites.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'SECURITY'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'We implement and maintain reasonable physical, technological and administrative security measures to protect all Personal Information from unauthorized access to or use, alteration, destruction or disclosure of such Personal Information. However, no method of transmission over the Internet, or method of electronic storage, is 100% secure. Therefore, although we take reasonable measures to protect and secure your Personal Information, we do not promise, and you should not expect, that your Personal Information, searches or other communications on or through the Website or the Services will always remain completely secure. You should also take care and reasonable precautions with how you handle and disclose your Personal Information and should avoid sending Personal Information through insecure email or other means. Please refer to the Federal Trade Commission\u2019s website at',
	                        _react2.default.createElement(
	                            'a',
	                            { href: 'http://www.ftc.gov/bcp/menus/consumer/data.shtm',
	                                target: '_blank' },
	                            'www.ftc.gov/bcp/menus/consumer/data.shtm'
	                        ),
	                        ' for information about how to protect yourself against identity theft. If we learn of a security breach that results in the unauthorized access to or disclosure of your Personal Information, we may attempt to notify you so that you can take appropriate protective steps. '
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'INTERNATIONAL TRANSFER'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'If you are located outside the United States and choose to provide information to us or we collect information about you, we transfer such information, including any Personal Information, to the United States and process it there. Your consent to this Privacy Policy and provision of such information (if applicable) represents your agreement to the foregoing transfer.'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'YOUR RIGHTS'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'General'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'You can do the following at any time by contacting us at ',
	                        data.site.siteMetadata.supportEmail,
	                        ' : (i) see what information we have about you, if any; (ii) request an update to or change any information we have about you; (iii) express any concern you have about our use of information we have about you.'
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        _react2.default.createElement(
	                            'em',
	                            null,
	                            'California Privacy Rights'
	                        ),
	                        _react2.default.createElement('br', null),
	                        'California Civil Code Section 1798.83 entitles California users to request information concerning whether a business has disclosed certain information about you to any third parties for the third parties\u2019 direct marketing purposes. California users who wish to request further information in compliance with this law or have questions or concerns about this Privacy Policy may contact us at ',
	                        data.site.siteMetadata.supportEmail,
	                        ' '
	                    ),
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'If you have any questions about this Privacy Policy, you may contact us at ',
	                        data.site.siteMetadata.supportEmail,
	                        ' '
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'h3',
	                        null,
	                        'CONTACT'
	                    )
	                )
	            ),
	            _react2.default.createElement(
	                'div',
	                { className: 'row' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'col-md-12' },
	                    _react2.default.createElement(
	                        'p',
	                        null,
	                        'If you have any questions about this Privacy Policy, you may contact us at ',
	                        data.site.siteMetadata.supportEmail,
	                        ' '
	                    )
	                )
	            )
	        )
	    );
	};
	
	exports.default = PrivacyPolicyPage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-privacy-policy-js-78bd799edbd9cc77bd86.js